export const cjCredentials = "/engagement/:app_group_id/cj_credentials_data";
